/*
 * All option state modifiers should go in this section.
 * This is obviously unconventional for our repo, but the story was requested to 1 million items,
 * and some of the operations would affect every item.
 * Given that their values are complex Objects instead of Strings memory management became important.
 * Reusing Objects also simplified traversal (parents/children) as well as traversal optimizations.
 */

/* eslint-disable no-param-reassign */
export function setParent(option, parent) {
  option.parent = parent;
}

// selectSingle is used to change a selected or partially-selected option into an unselected one.
// Non-leaves will need to handle running this on all of their descendants too.
export function unselectSingle(option) {
  option.selected = false;
  option.partialSelected = false;
}

// selectSingle is used to change an unselected or partially-selected option into a selected one.
// Non-leaves will need to handle running this on all of their descendants too.
export function selectSingle(option) {
  option.selected = true;
  option.partialSelected = false;
}

// Used on the parent node being collapsed (i.e. to show the arrow in the right direction)
export function collapseSingle(option) {
  option.collapsed = true;
}
// Used on the descendant nodes being collapsed (i.e. to filter them out / avoid rendering them)
export function collapseSingleDescendant(option) {
  option.collapseHidden = true;
}

export function uncollapseSingle(option) {
  option.collapsed = false;
}
export function uncollapseSingleDescendant(option) {
  option.collapsed = false;
  option.collapseHidden = false;
}

export function removeSearch(option) {
  option.searchVisible = null;
  option.highlightStart = null;
  option.highlightEnd = null;
}
export function setSearchDetails(option, { highlightStart, highlightEnd }) {
  option.searchVisible = true;
  option.highlightStart = highlightStart;
  option.highlightEnd = highlightEnd;
}
/*
 * setSearchVisible is Used for ancestors or descendants of a searched item. Basically the matched item will
 * have its text highlighted, but that item's ancestors and descendants need to be visible too. They likely
 * won't be highlighted, but this method does not wipe highlights in case they do exist.
 */
export function setSearchVisible(option) {
  option.searchVisible = true;
}
/* eslint-enable no-param-reassign */
